import type { ProvinceCodeType } from "./types"

export function calculateCost(loan: number, interestRate?: number) {
  const percentage = interestRate ? interestRate / 100 : 0.15
  return loan * percentage
}
